// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetailPPTX from '../../../containers/analytics/pptx/SecurityDetailPPTX';


const SecurityNonCriticalRudimentaryDetailPPTX = ({ data }) => {
  return (
    <SecurityDetailPPTX
      data={data}
      criticality='nonCritical'
      adequacy='rudimentary'
    />
  );
};

SecurityNonCriticalRudimentaryDetailPPTX.propTypes = {
  data: PropTypes.object
};

export default SecurityNonCriticalRudimentaryDetailPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/SecurityNonCriticalRudimentaryDetailPPTX.js